import React from 'react';
import { FileDownloadExperience } from '../FileDownloadExperience';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { IFileDownloadExperience } from '../types';

const rehydrator: RehydratorFunction = async (domNode) => {
  const props: IFileDownloadExperience = elementAttributesToProps(domNode);

  return Promise.resolve(<FileDownloadExperience {...props} />);
};

export default rehydrator;
